import { useWorkspaceStore } from "@/store/useWorkspaceStore";
import type { StaffWithdrawQuery } from "../../types";

interface Props {
  value: StaffWithdrawQuery;
  onChange: (val: StaffWithdrawQuery) => void;
}

export function BankMessage({ value, onChange }: Props) {
  const config = useWorkspaceStore((s) => s.config);
  const bankList = config?.user_extract_bank ?? [];

  return (
    <div className="bg-white rounded-2xl p-4 space-y-4">
      <span className="text-base font-bold text-gray-900">银行信息</span>

      {/* 开户行 */}
      <label className="flex items-center justify-between py-3 border-b border-gray-100">
        <span className="text-sm text-gray-500 w-[72px] shrink-0">开户行</span>
        <select
          value={value.bank_address}
          onChange={(e) => onChange({ ...value, bank_address: e.target.value })}
          className="flex-1 text-sm text-right outline-none bg-transparent text-gray-800"
        >
          <option value="">请选择</option>
          {bankList.map((bank, i) => (
            <option key={i} value={bank}>{bank}</option>
          ))}
        </select>
        <i className="ri-arrow-down-s-line text-gray-300 text-xs ml-2" />
      </label>

      {/* 持卡人姓名 */}
      <label className="flex items-center justify-between py-3 border-b border-gray-100">
        <span className="text-sm text-gray-500 w-[72px] shrink-0">持卡人</span>
        <input
          type="text"
          value={value.real_name}
          onChange={(e) => onChange({ ...value, real_name: e.target.value })}
          placeholder="真实姓名"
          className="flex-1 text-right text-sm outline-none bg-transparent text-gray-800 placeholder:text-gray-300"
        />
      </label>

      {/* 银行卡号 */}
      <label className="flex items-center justify-between pt-3 pb-1">
        <span className="text-sm text-gray-500 w-[72px] shrink-0">银行卡号</span>
        <input
          type="text"
          value={value.bank_code}
          onChange={(e) => onChange({ ...value, bank_code: e.target.value })}
          placeholder="输入卡号"
          className="flex-1 text-right text-sm outline-none bg-transparent text-gray-800 placeholder:text-gray-300"
        />
      </label>
    </div>
  );
}
